import React, { useEffect, useState } from "react";

const NurseGermanyCareer = () => {
  const [isMobile, setIsMobile] = useState(() => (typeof window !== "undefined" ? window.innerWidth <= 768 : false));

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ fontFamily: "'Segoe UI', Arial, sans-serif", maxWidth: "1100px", margin: "0 auto", padding: isMobile ? "20px 14px" : "30px 20px" }}>

      {/* Top Two-Column: Image Left, Content Right */}
      <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: isMobile ? "16px" : "30px", alignItems: "flex-start", marginBottom: isMobile ? "24px" : "40px" }}>

        {/* Left - Image */}
        <div style={{ flex: isMobile ? "0 0 auto" : "0 0 400px", width: isMobile ? "100%" : "400px" }}>
          <img
            src="https://images.unsplash.com/photo-1551076805-e1869033e561?w=600"
            alt="Nurse Career in Germany"
            style={{ width: "100%", height: isMobile ? "220px" : "320px", objectFit: "cover", borderRadius: "10px", display: "block" }}
          />
        </div>

        {/* Right - Main Intro Content */}
        <div style={{ flex: 1, width: "100%" }}>
          <h1 style={{ fontSize: "28px", color: "#1a3c5e", marginBottom: "15px" }}>Nursing Career in Germany</h1>
          <p style={{ fontSize: "15px", lineHeight: "1.7", color: "#444", marginBottom: "20px" }}>
            A nursing career in Germany offers excellent opportunities for both domestic and international nurses
            due to a high demand for skilled professionals and a strong healthcare system. Nurses can expect
            competitive salaries, job security, and opportunities for career advancement.
          </p>

          <h2 style={{ fontSize: "18px", color: "#1a3c5e", marginBottom: "8px" }}>Why Nursing in Germany?</h2>
          <p style={{ fontSize: "15px", lineHeight: "1.7", color: "#444", marginBottom: "16px" }}>
            With increasing life expectancy and an ageing society, the demand for professional nursing is rising.
            Hospitals, long-term care facilities, and other healthcare institutions are actively seeking skilled nurses,
            including international professionals.
          </p>

          <h2 style={{ fontSize: "18px", color: "#1a3c5e", marginBottom: "8px" }}>Competitive Salaries</h2>
          <p style={{ fontSize: "15px", lineHeight: "1.7", color: "#444" }}>
            A registered nurse in Germany can expect to earn a monthly salary between <strong>€2,500 to €3,500</strong>,
            with potential for higher earnings based on experience and specialization.
          </p>
        </div>
      </div>

      {/* More Details - Full Width Below */}
      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "20px", marginBottom: "30px" }}>
        {[
          { title: "High Demand & Job Security", text: "Germany faces a significant shortage of nurses, ensuring strong job security and long-term career prospects for qualified individuals." },
          { title: "Attractive Benefits", text: "Nurses are entitled to paid holidays including travel time, and enjoy access to a robust social safety net." },
          { title: "Work-Life Balance", text: "Germany emphasizes a healthy work-life balance, offering shorter work weeks and opportunities for overtime pay when needed." },
          { title: "Career Advancement", text: "Nurses are encouraged to pursue further education, with many institutions sponsoring advanced degrees for career growth." },
        ].map((item, i) => (
          <div key={i} style={{ background: "#f5f8fc", borderRadius: "10px", padding: "20px 24px" }}>
            <h3 style={{ fontSize: "16px", color: "#1a3c5e", marginBottom: "8px" }}>{item.title}</h3>
            <p style={{ fontSize: "15px", lineHeight: "1.7", color: "#444", margin: 0 }}>{item.text}</p>
          </div>
        ))}
      </div>

      {/* Entry Requirements */}
      <div style={{ background: "#eaf1f8", borderRadius: "10px", padding: "25px 30px", marginBottom: "30px" }}>
        <h2 style={{ fontSize: "20px", color: "#1a3c5e", marginBottom: "15px" }}>Entry Requirements for International Nurses</h2>
        <ul style={{ paddingLeft: "20px", fontSize: "15px", lineHeight: "2", color: "#444" }}>
          <li><strong>Recognized Qualification:</strong> Your nursing qualification must be recognized in Germany via equivalence assessment or an adaptation program.</li>
          <li><strong>German Language:</strong> At least B2 level proficiency is required.</li>
          <li><strong>Medical Fitness:</strong> A valid certificate proving physical and mental fitness.</li>
          <li><strong>Trustworthiness:</strong> Proof of no criminal record (good conduct certificate).</li>
        </ul>
      </div>

      {/* Inquiry Form */}
      <div style={{ background: "#f5f8fc", borderRadius: "10px", padding: isMobile ? "20px 16px" : "30px" }}>
        <h2 style={{ fontSize: "22px", color: "#1a3c5e", marginBottom: "20px" }}>Inquiry Form</h2>
        <div style={{ display: "flex", flexDirection: "column", gap: "15px", maxWidth: "600px" }}>
          <div>
            <label style={{ fontSize: "14px", fontWeight: "600", color: "#333", display: "block", marginBottom: "5px" }}>Name:</label>
            <input type="text" placeholder="Enter your name"
              style={{ width: "100%", padding: "10px 14px", fontSize: "15px", border: "1px solid #ccc", borderRadius: "6px", outline: "none" }} />
          </div>
          <div>
            <label style={{ fontSize: "14px", fontWeight: "600", color: "#333", display: "block", marginBottom: "5px" }}>Email:</label>
            <input type="email" placeholder="Enter your email"
              style={{ width: "100%", padding: "10px 14px", fontSize: "15px", border: "1px solid #ccc", borderRadius: "6px", outline: "none" }} />
          </div>
          <div>
            <label style={{ fontSize: "14px", fontWeight: "600", color: "#333", display: "block", marginBottom: "5px" }}>Message:</label>
            <textarea placeholder="Enter your message" rows={4}
              style={{ width: "100%", padding: "10px 14px", fontSize: "15px", border: "1px solid #ccc", borderRadius: "6px", outline: "none", resize: "vertical" }} />
          </div>
          <button type="button"
            style={{ width: isMobile ? "100%" : "160px", padding: "11px", background: "#1a3c5e", color: "#fff", fontSize: "15px", fontWeight: "600", border: "none", borderRadius: "6px", cursor: "pointer" }}>
            Submit
          </button>
        </div>
      </div>
          <div className="back-home-wrapper">
  <button className="back-home-btn" onClick={() => window.location.href = "/"}>
    ← Go Back to Home
  </button>
</div>
    </div>
  );
};

export default NurseGermanyCareer;